<template>
  <b-list-group-item
    class="sidebar-item"
    :button="button"
    :variant="variant"
    @click="$emit('click')"
    :to="to"
    :href="href"
    :disabled="disabled"
  >
    <slot></slot>
    <div class="sidebar-item__icon">
      <slot name="icon"></slot>
    </div>
  </b-list-group-item>
</template>

<script>
export default {
  props: {
    button: {
      type: Boolean,
      required: false
    },
    variant: {
      type: String,
      required: false
    },
    to: {
      type: String,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style lang="scss">
.sidebar-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__icon {
    margin-left: 5px;
    display: flex;
    align-items: center;
    font-size: 1rem;
  }
}
</style>
